import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { capitalizeFirstLetter } from "../../../../utilities";

class AddEditModal extends Component {
  render() {
    let errorPlaceholder;
    if (this.props.errorMessage && this.props.errorMessage.trim().length > 0) {
      errorPlaceholder = (
        <p className="alert alert-danger" dangerouslySetInnerHTML={{ __html: this.props.errorMessage }}></p>
      );
    } else {
      errorPlaceholder = null;
    }
    return (
      <Modal
        dialogClassName={this.props.dialogClassName ? this.props.dialogClassName : ""}
        backdrop="static"
        show={this.props.showModal}
        onHide={this.props.onHideModal}
        tabIndex="1"
        // eslint-disable-next-line react/jsx-no-duplicate-props
        tabindex="none"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {capitalizeFirstLetter(this.props.action)} {this.props.type}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorPlaceholder}
          {this.props.children}
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-primary" onClick={this.props.save}>
            Save
          </Button>
          <Button onClick={this.props.onHideModal}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default AddEditModal;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Common/AddEditModal.js